import { useSelector } from "react-redux";
import { getPrecision } from "@shared/utils/precision";
import { selectDisplayCurrency } from "@shared/slices/common.slice";
import { useCallback } from "react";
import { PrecisionConfig, PrecisionType } from "@shared/types";

const usePrecision = (
  precisionSelector?: (state: any) => PrecisionConfig | {} | undefined,
  precisionConfig?: PrecisionConfig
) => {
  const defaultSelector = useCallback(() => undefined, []);
  const _precisionConfig = useSelector(precisionSelector || defaultSelector);
  const displayCurrency = useSelector(selectDisplayCurrency);

  return {
    getPrecision: (
      precisionType?: PrecisionType,
      coin?: string,
      exchange?: string
    ) =>
      getPrecision(
        _precisionConfig || precisionConfig || {},
        precisionType,
        displayCurrency,
        coin,
        exchange
      ),
  };
};
export default usePrecision;
